/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu

import { createUseStyleTokens } from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule

const data = {
  base: `${"plasmic_tokens_bvRZj1oZhhFBeMnkX2LkQu"} ${"plasmic_tokens_ohDidvG9XsCeFumugENU3J"}`,
  varianted: []
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);
